import { Component, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SanitizerPipe } from "../../../pipes/sanitizer.pipe";
import { SVG_ICONS } from "../../../models/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ActivatedRoute } from "@angular/router";
import { MasterService } from "@frontend/app/serivces/master.service";

@Component({
  selector: "app-member-enrolled-page",
  imports: [CommonModule, SanitizerPipe],
  templateUrl: "./member-enrolled-page.component.html",
  styleUrl: "./member-enrolled-page.component.scss",
})
export class MemberEnrolledPageComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private masterService = inject(MasterService);

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.studentID = +params["StudentID"];
      this.classID = +params["ClassID"];
    });
    this.getStudentPackageSubscriptionsDetailsByID();
  }

  //#region  variables
  readonly SVG_ICONS = SVG_ICONS;

  studentID = 0;
  classID = 0;
  studentData: any;
  activeSubscription: any;
  activeEnrollment: any;
  //#endregion

  //#region get
  getStudentPackageSubscriptionsDetailsByID() {
    this.masterService.getStudentByID(this.studentID).subscribe((res: any) => {
      const { data } = res;
      this.studentData = data;
      this.activeSubscription = data.packageSubscriptions?.find((x: any) => x.IsActive);
      this.activeEnrollment = data.classEnrollments?.find((x: any) => x.IsActive);
    });
  }
  getActiveClassName(studentData: any): string {
    const activeEnrollment = studentData?.classEnrollments?.find((c: any) => c.IsActive);
    return activeEnrollment?.classDetails?.ClassName || "";
  }

  //#endregion
  // PDF download karne wala function
  downloadReceipt() {
    const doc = new jsPDF();
    const data = this.studentData;

    const activeSubscription = data.packageSubscriptions?.find((x: any) => x.IsActive);
    const activeClass = data.classEnrollments?.find((x: any) => x.IsActive);

    doc.setFontSize(22);
    doc.text("Membership Receipt", 105, 25, { align: "center" });

    doc.setFontSize(12);
    doc.text(`Member Name: ${data.FirstName} ${data.LastName}`, 15, 45);
    doc.text(`Member ID: ${data.StudentID}`, 15, 52);
    doc.text(`Date: ${new Date(activeSubscription?.StartDate ?? new Date()).toLocaleDateString("en-GB")}`, 195, 45, { align: "right" });

    autoTable(doc, {
      startY: 65,
      head: [["Description", "Details"]],
      body: [
        ["Membership Plan", activeSubscription?.packageDetails?.PackageName ?? "N/A"],
        ["Assigned Class", activeClass?.classDetails?.ClassName ?? "N/A"],
        ["Start Date", activeSubscription?.StartDate ? new Date(activeSubscription.StartDate).toLocaleDateString("en-GB") : "N/A"],
        ["End Date", activeSubscription?.EndDate ? new Date(activeSubscription.EndDate).toLocaleDateString("en-GB") : "N/A"],
        ["Transaction ID", `TXN${activeSubscription?.SubscriptionID}`],
        ["Payment Mode", "UPI"],
        [
          { content: "Amount Paid", styles: { fontStyle: "bold" } },
          { content: `${activeSubscription?.TotalAmount ?? 0}`, styles: { fontStyle: "bold" } },
        ],
      ],
      theme: "grid",
      headStyles: { fillColor: [22, 27, 34] },
    });

    const finalY = (doc as any).lastAutoTable.finalY;
    doc.setFontSize(10);
    doc.text("Thank you for your payment!", 105, finalY + 20, { align: "center" });

    doc.save(`Receipt-TXN${activeSubscription?.SubscriptionID}.pdf`);
  }
}
